import { render } from "./FillInformationMemberships.vue?vue&type=template&id=652bc0e4"
import script from "./FillInformationMemberships.vue?vue&type=script&lang=js"
export * from "./FillInformationMemberships.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__